<template>
    <div class="terms">
        <h1>제1장 총칙</h1>
        <h2>제1조 (목적)</h2>
        <p
            >본 약관은 주식회사 매일국어(이하 회사라고 합니다.)가 운영하는 웹사이트 매일국어T(school.dailykor.com, 이하
            “웹사이트”라고 합니다.)를 통하여 제공하는 교육서비스(이하 서비스라고 합니다.)의 이용과 관련하여 회사와
            이용자 사이에 권리와 의무 및 기타 필요한 사항을 규정하는 것을 목적으로 합니다.</p
        >
        <h2></h2>
        <h2>제2조 (정의)</h2>
        <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
        <ol>
            <li>서비스 : 회사가 운영하는 웹사이트를 통해 제공하는 모든 교육서비스를 말합니다.</li>
            <li
                >이용자 : 회사의 웹사이트에 접속하여 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을
                말합니다.</li
            >
            <li
                >회원 : 회사의 웹사이트에 접속하여 본 약관에 동의함으로써 회사와 이용계약을 체결하고 아이디(ID)를
                부여받은 이용자로서 회사가 제공하는 정보와 온라인 서비스를 지속적으로 이용할 수 있는 자를 말합니다.</li
            >
            <li
                >아이디(ID) : 이용자의 식별 및 서비스 이용을 위하여 이용자가 정하고 회사가 승인하는 영문과 숫자의 조합을
                말합니다.</li
            >
            <li
                >비밀번호(Password) : 서비스 이용 시, 아이디와 일치되는 이용자임을 확인하고 이용자의 개인정보 보호를
                위하여 이용자 자신이 정한 영문과 숫자의 조합을 말합니다.</li
            >
            <li
                >콘텐츠 : 회사에서 제공하는 모든 서비스 및 기타 관련 정보를 의미하며, 정보통신망 이용촉진 및 정보보호
                등에 관한 법률 제2조 제1항 제1호의 규정에 의한 정보통신망에서 사용되는 부호, 문자, 음성, 음향, 이미지,
                영상 등으로 표현된 자료 또는 정보를 의미합니다.</li
            >
            <li>무료 체험 : 정식 계약 체결 전에 제공된 기간 동안 무료로 서비스를 이용해보는 것을 말합니다.</li>
            <li>운영자 : 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람 또는 회사를 말합니다.</li>
            <li
                >이 약관에서 사용하는 정의는 본 조에서 정하는 것을 제외하고는 관계법령 및 서비스 별 안내에서 정하는 바에
                의합니다.</li
            >
        </ol>
        <h2>제3조 (약관의 효력과 변경)</h2>
        <ol>
            <li
                >본 약관은 회원이 약관의 내용에 동의하며 회원가입을 신청하고, 회사가 그 신청에 대하여 승낙함으로써
                효력이 발생합니다.</li
            >
            <li
                >회사가 본 약관의 내용을 변경하는 경우 기존 회원들에게는 제5조에서 명시한 방법으로 통지함으로써 효력이
                발생합니다.</li
            >
            <li
                >회사는 합리적인 사유가 발생할 경우 약관의 규제에 관한 법률, 정보통신망 이용 촉진 및 정보보호 등에 관한
                법률(이하 &quot;정보통신망법&quot;) 등의 관련 법령에 위배되지 않는 범위 안에서 약관을 개정할 수
                있습니다.</li
            >
            <li
                >개정된 약관에 이용자의 권리 또는 의무 등 중요한 규정의 개정이 있는 경우 사전에 공지합니다. 다만,
                회원에게 불리한 약관의 개정의 경우에는 전자우편, 로그인 시 동의 등의 전자적 수단을 통해 따로 명확히
                통지하도록 합니다.</li
            >
            <li
                >회사가 전항에 따라 개정 약관을 공지 또는 통지하면서 회원에게 7일 기간 내에 의사표시를 하지 않으면
                의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의
                의사표시를 하지 아니한 경우 회원이 개정 약관에 동의한 것으로 봅니다.</li
            >
            <li
                >이 약관에 동의하는 것은 정기적으로 웹사이트를 방문하여 약관의 변경사항을 확인하는 것에 동의함을
                의미합니다. 변경된 약관에 대한 정보를 알지 못해 발생하는 이용자의 피해는 회사에서 책임지지 않습니다.</li
            >
            <li>회원이 변경된 약관에 동의하지 않을 경우 회사는 해당 회원의 탈퇴(해지)를 요청할 수 있습니다.</li>
        </ol>
        <h2>제4조 (약관 외 준칙)</h2>
        <p
            >이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 온라인 디지털콘텐츠산업 발전법, 전자상거래
            등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 정보통신부 장관이 정하는 디지털콘텐츠 이용자
            보호지침, 기타 관계 법령 또는 상관례에 따릅니다.</p
        >
        <h2>제5조 (회원에 대한 통지)</h2>
        <ol>
            <li
                >회사는 회원에게 알려야 할 상황이 발생하는 경우 이메일, 문자 등을 보내거나, 서비스 내에 공지 또는
                팝업창을 게시하는 방법 등으로 통지할 수 있습니다.</li
            >
            <li
                >전 항과 같이 통지한 경우 그때부터 7일 이내에 회원이 회사가 정하는 방법으로 그 통지 내용에 동의하지
                않음을 표시하지 않을 경우 그 회원에게는 통지 내용이 도달하였고 통지 내용에 동의하였다고 간주합니다.</li
            >
            <li>통지 내용에 동의하지 아니하는 회원은 회사에 회원 탈퇴를 요청할 수 있습니다.</li>
        </ol>
        <h1>제2장 회원가입</h1>
        <h2>제6조 (회원가입 및 회원가입 신청)</h2>
        <ol>
            <li
                >회원가입은 서비스를 이용하기 위해 회원이 되고자 하는 자(이하 “가입 신청자&quot;)가 약관의 내용에 대하여
                동의를 하고, 회사가 정한 가입 양식에 따라 회원 정보를 기입하여 회원 가입 신청을 하고 이러한 신청에
                대하여 회사가 승낙함으로써 체결됩니다.</li
            >
            <li
                >전 항의 규정에 따라 회원가입을 할 때에는 회사가 제공하는 서비스의 원활한 이용을 위해 필요한 개인정보를
                제공해야 합니다.</li
            >
        </ol>
        <h2>제7조 (회원가입 신청에 대한 승낙)</h2>
        <ol>
            <li
                >승낙은 회사가 가입 신청자에게 아이디를 부여함과 동시에 서비스 이용 개시를 통보함으로써
                이루어집니다.</li
            >
            <li
                >회사는 다음 각 호에 해당하는 신청에 대하여는 승인을 하지 않거나 사후에 이용계약을 해지할 수
                있습니다.<br />
                ① 이용자가 이 약관에 의해 회원 자격을 상실한 적이 있는 경우. 단, 회사의 승낙을 얻은 경우에는 예외로
                함.<br />
                ② 이용자의 귀책사유로 인하여 승인이 불가능한 경우<br />
                ③ 허위로 또는 오기로 정보를 기재한 경우<br />
                ④ 실명이 아니거나 타인 명의 또는 개인 정보를 도용한 경우<br />
                ⑤ 위법, 불법 행위 등 부정한 용도로 서비스를 이용하고자 하는 경우<br />
                ⑥ 회사가 제시하는 서비스 이용 계약 신청 양식에 관련 내용을 기재하지 않은 경우<br />
                ⑦ 본 약관 및 관계 법령을 위반하는 경우<br />
                ⑧ 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우<br />
                ⑨ 회원가입 양식에 기재되어 회사에 제공되는 개인정보(ID, 비밀번호, 주소 등)가 선량한 풍속 기타 사회질서에
                위배되거나 타인을 모욕하는 경우</li
            >
            <li
                >회사는 서비스 이용 신청이 다음 각 호에 해당하는 경우에는 그 신청에 대하여 승낙 제한 사유가 해소될
                때까지 승낙을 유보할 수 있습니다.<br />
                ① 회사가 설비의 여유가 없는 경우<br />
                ② 회사의 기술상 지장이 있는 경우<br />
                ③ 기타 회사의 귀책사유로 이용 승낙이 곤란한 경우</li
            >
            <li
                >모든 회원은 반드시 이용자 본인의 회원가입에 필요한 정보를 제공하여야만 서비스를 이용할 수 있으며,
                정확한 정보로 등록하지 않은 회원은 일체의 권리를 주장할 수 없습니다.</li
            >
            <li
                >회원가입은 회원 본인과 연락 가능한 정확한 정보로 가입해야 하며, 회사는 관리 및 본인 확인 등을 위한 정보
                확인 조치를 할 수 있습니다.</li
            >
            <li
                >타인의 정보를 도용하여 이용 신청을 한 회원의 모든 아이디는 삭제되며 관계 법령에 따라 처벌을 받을 수
                있습니다.</li
            >
        </ol>
        <h2>제8조 (회원정보의 변경)</h2>
        <ol>
            <li>회원은 서비스의 정보 수정 페이지에서 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다.</li>
            <li>회원이 전항의 변경사항을 수정하지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.</li>
        </ol>
        <h1>제3장 서비스 제공 및 이용</h1>
        <h2>제9조 (서비스 이용 범위 및 이용 시간)</h2>
        <ol>
            <li
                >회사는 서비스 제공과 관련한 회사 정책의 변경 등 기타 상당한 이유가 있는 경우 등 운영상, 기술상의 필요에
                따라 제공하고 있는 서비스의 전부 또는 일부를 변경 또는 중단할 수 있습니다.</li
            >
            <li
                >서비스는 회사의 업무상, 기술상 문제 등 기타 특별한 사정이 없는 한 매일 24시간 운영함을 원칙으로
                합니다.</li
            >
            <li
                >회사는 일부 서비스의 이용 가능 시간을 별도로 정할 수 있으며, 이 경우 사전에 서비스 제공 화면에
                공지합니다.</li
            >
            <li
                >회사는 서비스의 원활한 수행을 위하여 필요한 기간을 정하여 사전에 공지하고 서비스를 중지할 수 있습니다.
                단, 불가피하게 긴급한 조치를 필요로 하는 경우 사후에 통지할 수 있습니다.</li
            >
            <li
                >회사는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수
                있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.</li
            >
        </ol>
        <h2>제10조 (서비스 이용계약의 성립 및 결제방법)</h2>
        <ol>
            <li
                >회원은 회사가 제공하는 다음 각호 또는 이와 유사한 절차에 의하여 콘텐츠 서비스 이용을 신청을 합니다.
                회사는 계약 체결 전, 다음 각호의 사항에 관하여 회원이 정확하게 이해하고 실수 또는 착오 없이 거래할 수
                있도록 정보를 제공합니다.<br />
                ① 콘텐츠 목록의 열람 및 선택<br />
                ② 콘텐츠 상세정보 확인<br />
                ③ 결제하기 클릭<br />
                ④ 주문 상품 및 결제금액 확인(환불 규정 안내)<br />
                ⑤ 이름, 주소, 연락처 등 배송지 정보 입력<br />
                ⑥ 결제금액 및 가상계좌 정보 확인<br />
                ⑦ 가상계좌 송금을 통한 결제</li
            >
            <li
                >회원은 신용카드, 무통장입금, 인터넷 계좌이체, 휴대폰 결제 등 회사에서 정하고 있는 방법으로 유료서비스의
                결제가 가능합니다. 다만, 각 결제수단마다 결제수단의 특성에 따른 일정한 제한이 있을 수 있습니다.</li
            >
            <li
                >미성년 회원의 결제는 원칙적으로 보호자의 명의 또는 보호자 동의하에 이루어져야 하고, 보호자는 본인 동의
                없이 체결된 자녀(미성년자)의 계약을 취소할 수 있습니다.</li
            >
            <li
                >미성년자가 유료서비스의 대금을 자신의 명의로 결제하는 경우, 당해 미성년자는 보호자의 승낙을 증명하는
                문서, 전자우편 등을 제공하거나 유·무선을 통하여 확인을 할 수 있도록 보호자의 연락처를 제공하여야 합니다.
                만약 이러한 절차를 이행하지 않을 경우 결제금액은 보호자에 의하여 처분이 허락된 재산으로 볼 수
                있습니다.</li
            >
            <li>회사는 보호자의 동의 여부를 유·무선 등의 방법을 통하여 확인할 수 있습니다.</li>
            <li
                >회사는 회원의 유료서비스 이용 신청이 다음 각호에 해당하는 경우에는 승낙하지 않거나, 그 사유가 해소될
                때까지 승낙을 유보할 수 있습니다.<br />
                ① 유료 서비스의 이용요금을 납입하지 않는 경우<br />
                ② 유료 서비스 신청금액 총액과 입금 총액이 일치하지 않은 경우<br />
                ③ 기타 합리적인 이유가 있는 경우로서 회사가 필요하다고 인정되는 경우</li
            >
            <li
                >회사는 회원이 본조 위 조항의 절차에 따라 유료서비스 이용을 신청할 경우, 승낙의 의사표시로써 본 약관
                제5조의 방법을 통하여 회원에게 통지하고, 승낙의 통지가 회원에게 도달한 시점에 계약이 성립한 것으로
                봅니다.</li
            >
            <li
                >회사의 승낙의 의사표시에는 회원의 이용 신청에 대한 확인 및 서비스 제공 가능 여부, 이용 신청의 정정,
                취소 등에 관한 정보 등을 포함합니다.</li
            >
        </ol>
        <h2>제11조 (서비스 제공의 중지 및 제한)</h2>
        <ol>
            <li
                >회사는 컴퓨터 등 정보통신 설비의 보 수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는
                서비스의 제공을 일시적으로 중단할 수 있습니다.</li
            >
            <li
                >회사는 다음 각 호에 해당하는 경우 서비스 제공을 중지하거나 제한할 수 있습니다.<br />
                ⓛ 서비스용 설비의 최적화를 위한 시스템 점검 또는 설비 보수로 인해 부득이한 경우<br />
                ② 분산서비스 거부 공격(DDoS) 등에 의해 발생한 서비스 장애 복구를 위해 부득이한 경우<br />
                ③ 기타 서비스용 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우<br />
                ④ 전기통신사업법에 규정된 기간통신 사업자가 전기통신 서비스를 중지했을 경우<br />
                ⑤ 국가비상사태, 천재지변에 의해 부득이한 경우<br />
                ⑥ 기타 합리적인 이유가 있는 경우로서 회사가 필요하다고 인정하는 경우</li
            >
            <li
                >회사가 전 항들에 의하여 서비스 제공을 중지하거나 제한하는 경우 회사는 이를 사전 또는 사후에 회원에게
                알려야 합니다. 다만, 회사의 귀책사유 없이 회원에게 통지할 수 없는 경우에는 예외로 합니다.</li
            >
            <li
                >회사와 계약한 출판사와의 계약 종료 및 변경 등의 사유로 서비스의 내용이 변경되거나, 서비스가 중단될 수
                있습니다.</li
            >
            <li>전항의 사유로 서비스가 일시적으로 중단되는 경우 회사는 제5조에 정한 방법으로 이용자에게 통지합니다.</li>
            <li
                >회사의 귀책사유로 인하여 회원이 이용권(정액제) 서비스 이용 기간 동안 서비스를 제공받을 수 없게 되는
                경우, 회사는 회원이 그 기간만큼 이용할 수 있는 기간을 늘리거나 동일 및 유사한 콘텐츠를 다시
                제공합니다.</li
            >
            <li
                >사업 종목의 전환, 사업의 포기, 업체간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는
                제5조에 정한 방법으로 회원에게 통지하고 당초 회사에서 제시한 조건에 따라 회원에게 보상합니다.</li
            >
        </ol>
        <h2>제12조 (회사의 의무)</h2>
        <ol>
            <li
                >회사는 관련법과 이 약관이 금지하는 행위 및 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로
                서비스를 제공하기 위하여 최선을 다하여 노력합니다.</li
            >
            <li
                >회사는 회원이 서비스를 이용하는 과정에서 회원 개인정보가 외부로 유출되지 않도록 방화벽을 설치하는 등
                별도의 보안장치를 사용하고 있으며, 그 구체적인 내용은 회사 웹사이트의 “개인정보 처리방침”에서 확인할 수
                있습니다.</li
            >
            <li>회사는 회원이 유료서비스 이용 및 그 결제 내역을 수시로 확인할 수 있도록 조치합니다.</li>
            <li
                >회사는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 지체
                없이 처리합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편, 전화 등을
                통하여 그 처리 과정 및 결과를 전달합니다.</li
            >
        </ol>
        <h2>제13조 (회원의 의무)</h2>
        <ol>
            <li
                >회사의 명시적 동의가 없는 한 회원의 이용권한은 회원 개인에 한정되며, 타인에게 양도, 증여하거나 이를
                담보 등으로 제공할 수 없습니다.</li
            >
            <li
                >회사는 회원이 다음 각호에 해당하는 의무를 위반하였을 경우, 기간을 정하여 전부 또는 일부의 서비스 이용을
                중지하거나 상당 기간의 최고 후 이용계약을 해지할 수 있습니다.<br />
                ⓛ 회원가입 신청 또는 변경 시 허위 내용을 등록하는 경우<br />
                ② 다른 회원의 아이디, 비밀번호를 도용하는 경우<br />
                ③ 회사의 서비스에 게시된 정보를 변경하거나 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 영리 또는
                비영리의 목적으로 복제, 출판, 방송 등에 사용하거나 제3자에게 제공하는 행위<br />
                ④ 회사 기타 제3자에 대한 허위의 사실을 게재하거나 지적재산권을 침해하는 등 회사나 제3자의 권리를
                침해하는 행위<br />
                ⑤ 회사의 직원, 서비스 운영자 또는 관계자를 사칭하는 행위<br />
                ⑥ 공공질서 및 미풍양속에 위배되는 내용의 정보, 문장, 도형 등을 유포하는 행위<br />
                ⑦ 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위<br />
                ⑧ 회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위<br />
                ⑨ 반국가적, 반사회적, 범죄적 행위와 결부된다고 판단되는 행위<br />
                ⑩ 본 약관을 포함하여 기타 회사가 정한 제반 규정 또는 이용 조건을 위반하는 행위</li
            >
        </ol>
        <h2>제14조 (저작권)</h2>
        <ol>
            <li>회사가 자체 제작한 모든 콘텐츠에 대한 저작권은 회사에 있습니다.</li>
            <li
                >회원이 서비스 내에 게시하는 게시물 및 생성한 콘텐츠는 검색 결과 내지 서비스 및 관련 프로모션 등에
                노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이
                경우, 회사는 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당
                게시물에 대해 삭제, 검색 결과 제외, 비공개 등의 조치를 취할 수 있습니다.</li
            >
            <li
                >회사가 제3자로부터 이용 허락을 받은 콘텐츠에 대한 저작권은 제3자에게 있고 회사는 그에 대한 사용권을
                가집니다.</li
            >
            <li
                >회원은 회사가 제공하는 서비스를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포,
                방송 기타 방법에 의하여 영리, 비영리의 목적으로 이용하거나 제3자에게 이용하게 할 수 없습니다.</li
            >
            <li
                >회사는 회사 또는 제3자의 저작권을 보호하기 위하여 회원이 서비스를 이용하는 동안 회원의 유·무선 기기의
                소프트웨어가 실행되는 것을 감지하여 자동으로 차단하는 프로그램을 사용할 수 있습니다.</li
            >
        </ol>
        <h1>제4장 회원 탈퇴 및 자격 상실</h1>
        <h2>제15조 (이용계약의 종료)</h2>
        <ol>
            <li
                >회원이 서비스의 중단을 요구하는 경우에는 회원 본인 또는 회원의 법정대리인이 회사가 요구하는 절차에 따라
                회원 탈퇴 신청을 하여야 합니다.</li
            >
            <li
                >회원의 회원 탈퇴 신청을 확인한 경우 회사는 신속히 회원 탈퇴 절차를 처리하며, 관련법 및 개인정보
                처리방침에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 탈퇴 완료 후 지체 없이 회원의 개인정보를
                파기합니다.</li
            >
            <li
                >회원이 계약을 해지할 경우, 관련법 및 개인정보 처리방침에 따라 회사가 일정 기간 회원정보를 보유할 수
                있습니다.</li
            >
        </ol>
        <h2>제16조 (회원 자격 상실 및 정지)</h2>
        <ol>
            <li
                >회사는 회원이 제15조에 위반하는 행위를 하였을 경우, 사전 통지 없이 경고, 일시정지, 영구이용 정지 등을
                통해 회원 자격을 상실 또는 정지시킬 수 있습니다.</li
            >
            <li
                >회사가 전 항에 따라 회원 자격을 상실시키거나 제한하는 경우에는 회사는 이를 회원에게 알립니다. 다만,
                회사의 귀책사유 없이 회원에게 알릴 수 없는 경우에는 예외로 합니다.</li
            >
            <li
                >회사가 본 조 제1항에 따라 회원 자격을 상실시키거나 제한하는 경우 해당 회원에 대하여는 회사가 제공하는
                모든 서비스의 이용을 중단시킬 수 있고, 해당 회원은 회사에 대하여 중단 이후의 서비스에 대한 환불을 요구할
                수 없습니다.</li
            >
            <li
                >회사는 회원이 계속해서 1년 이상 로그인하지 않는 경우, 회원정보의 보호 및 운영의 효율성을 위해 이용을
                제한할 수 있습니다.</li
            >
            <li
                >본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 회사는 제5조에 명시된 방침에 따라
                통지합니다.</li
            >
            <li
                >회원은 본 조에 따른 이용 제한 등에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이때 이의가
                정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.</li
            >
            <li
                >본 조에 따라 이용 제한이 되는 경우 서비스 이용을 통해 획득한 혜택 등도 모두 이용 중단, 또는 소멸되며,
                회사는 이에 대해 별도로 보상하지 않습니다.</li
            >
        </ol>
        <h1>제5장 청약 철회 및 환불</h1>
        <h2>제17조 (청약 철회)</h2>
        <ol>
            <li
                >회원은 회사로부터 재화 등의 내용이 회사가 표시·광고한 내용과 다르거나 계약내용과 다르게 이행된 경우에는
                그 재화 등을 공급받은 날부터 7일 이내에 청약철회가 가능합니다.</li
            >
            <li
                >서비스에 대한 취소 및 환불 규정은 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령을
                준수합니다.</li
            >
            <li
                >회사는 별도의 취소 및 환불 관련 규정을 정할 수 있으며, 이 경우 별도 계약 및 이용조건 상의 취소 및 환불
                규정이 우선 적용됩니다.</li
            >
            <li
                >다음 각호의 경우에는 회원의 청약철회가 제한됩니다.<br />
                ① 회원의 책임 있는 사유로 재화 등이 멸실되거나 훼손된 경우. 다만, 재화 등의 내용을 확인하기 위하여 포장
                등을 훼손한 경우 제외<br />
                ② 회원의 사용 또는 일부 소비로 재화 등의 가치가 현저히 감소한 경우<br />
                ③ 시간이 지나 다시 판매하기 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우<br />
                ④ 복제가 가능한 재화 등의 포장을 훼손한 경우</li
            >
        </ol>
        <h2>제18조 (환불 규정)</h2>
        <ol>
            <li
                >회사의 부득이한 사정으로 유료서비스를 지속할 수 없을 경우, 회원이 지정하는 계좌로 환불 처리합니다. 단,
                잔여이용료 환불 시 회사가 규정한 환불 정책에 따릅니다.</li
            >
            <li
                >회사는 다음 각호에 해당하는 경우 회사의 규정에 따라 회원의 결제금액을 환불합니다.<br />
                ① 회사가 서비스를 제공할 수 없는 경우<br />
                ② 회원이 제19조에 의거하여 회사 고객센터에 환불 의사를 밝히거나 웹사이트에서 취소 처리를 한 경우<br />
                ③ 그 밖에 회사가 인정하는 경우</li
            >
            <li
                >회사는 다음 각 호에 해당하는 경우 회원의 환불 신청이 제한됩니다.<br />
                ① 회원의 실수로 이용 기간 내에 서비스를 이용하지 못한 경우<br />
                ② 환불 관련 제 비용이 잔여 이용료를 초과할 경우<br />
                ③ 서비스에서 탈퇴한 후, 환불을 요구할 경우<br />
                ④ 기타 정당한 환불 사유로 판명되지 않은 경우</li
            >
            <li
                >회사의 이용금액 취소 및 환불은 회사의 확인 후 7영업일 이내에 처리됩니다. 다만, 회사의 책임 영역 외의
                신용카드 결제, 가상 계좌, 실시간 계좌 이체 및 핸드폰 결제는 신용카드사, 은행 및 PG사, 이동통신사의 환불
                기준에 의거하여 처리가 완료되는 데에 시일이 소요될 수 있습니다. 해당 사유로 취소 및 환불이 지연될 경우
                회사가 책임지지 않습니다.</li
            >
        </ol>
        <h2>제19조 (과오금)</h2>
        <ol>
            <li
                >회사는 과오금이 발생할 경우 서비스 이용금액의 결제와 동일한 방법으로 과오금 전액을 환불하여야 합니다.
                다만, 동일한 방법으로 환불이 불가능할 때는 이를 사전에 고지합니다.</li
            >
            <li
                >회사의 책임 있는 사유로 과오금이 발생한 경우 회사는 계약비용, 수수료 등에 관계없이 과오금 전액을
                환불합니다. 다만, 회원의 책임 있는 사유로 과오금이 발생한 경우, 회사가 과오금을 환불하는 데 소요되는
                비용은 합리적인 범위 내에서 회원이 부담하여야 합니다.</li
            >
            <li
                >회사는 서비스 사용료를 과소납입한 회원에게 해당 금액에 해당하는 부분을 추가로 청구할 수 있으며, 청구에
                대해 불응시 서비스 중지 및 제공기간이 축소될 수 있습니다.</li
            >
        </ol>
        <h1>제6장 기타</h1>
        <h2>제20조 (손해 배상)</h2>
        <ol>
            <li
                >회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다. 유료
                서비스에 관하여는 가입자가 낸 요금범위 내에서 손해배상 할 수 있습니다.</li
            >
            <li
                >회원의 불법적 행위 및 본 약관의 규정 위반으로 회사에 손해가 발생하거나 제3자로부터 손해배상 청구 또는
                각종 이의제기가 발생할 경우 당해 회원은 회사에 발생하는 손해를 배상하여야 합니다.</li
            >
        </ol>
        <h2>제21조 (면책 조항)</h2>
        <ol>
            <li
                >회사는 천재지변 또는 이에 따르는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에
                관한 책임이 면제됩니다.</li
            >
            <li>회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</li>
            <li
                >회사는 회원이 서비스에 게재한 사실의 신뢰도, 정보나 자료의 정확성 등 내용에 관하여는 책임을 지지
                않습니다.</li
            >
            <li
                >회사는 서비스 이용과 관련하여 회원에게 발생한 손해 가운데 신상정보 및 전자우편 주소를 부실하게 기재하는
                등 회원의 고의, 과실에 의한 손해에 대하여 책임을 지지 않습니다.</li
            >
            <li
                >회사는 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우
                책임이 면제됩니다.</li
            >
            <li
                >회사는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이
                면제됩니다.</li
            >
            <li
                >회사는 회원이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을 지지
                않습니다.</li
            >
            <li
                >회사는 회원이 서비스를 이용하면서 얻은 자료로 인한 손해에 대하여 책임을 지지 않습니다. 또한 회사는
                회원이 서비스를 이용하며 타 회원으로 인해 입게 되는 정신적 피해에 대하여 보상할 책임을 지지
                않습니다.</li
            >
            <li
                >회사는 이용자 상호간 및 이용자와 제3자 상호 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가
                없으며, 이로 인한 손해를 배상할 책임도 없습니다.</li
            >
            <li>회사에서 회원에게 무료로 제공하는 서비스의 이용과 관련해서는 어떠한 손해도 책임을 지지 않습니다.</li>
        </ol>
        <h2>제22조 (분쟁의 해결)</h2>
        <ol>
            <li
                >회사는 분쟁이 발생하였을 경우에 회원이 제기하는 정당한 의견이나 불만을 반영하여 적절하고 신속한 조치를
                취합니다. 다만, 신속한 처리가 곤란한 경우에 회사는 회원에게 그 사유와 처리일정을 통보합니다.</li
            >
            <li
                >전항에도 불구하고, 본 약관 및 서비스이용 및 회원과 회사 관련 사항 등은 모두 대한민국 법령의 적용을
                받습니다.</li
            >
            <li
                >회원은 회사의 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사의 본사 소재지를 관할하는
                법원을 관할법원으로 합니다.</li
            >
        </ol>
        <h2>부칙</h2>
        <p>이 약관은 2025년 01월 01일부터 적용됩니다.</p>
    </div>
</template>

<script setup lang="ts">
    import { PropType } from 'vue';

    const props = defineProps({
        className: {
            type: String as PropType<string>,
            required: false,
            default: null,
        },
    });
</script>
